/* eslint-disable react/jsx-props-no-spreading */
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

export default function AppAlert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
